import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import envConfig from '@hulu/env-config';

export const initDatadogRum = () => {
  datadogRum.init({
    applicationId: envConfig.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: envConfig.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'ads-support-tool',
    env: envConfig.NODE_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
  });
};
